<template>
    <main class="stats">
        <section class="list-banner">
            <div class="overlay"></div>
            <h1 class="banner-title">Places</h1>
        </section>
        <SubMenu parent-route-name="stats" />
        <LoadingScreen v-if="!loaded" message="Loading place statistics…" />
        <section v-else class="stat-blocks max-width-container">
            <article>
                <h2>Visited Places</h2>
                <DataTable :table="table" />
            </article>
            <article>
                <h2>Hosts</h2>
                <BaseChart name="Host" :options="hostChart" />
            </article>
            <article>
                <h2>Impressions</h2>
                <BaseChart name="Impression" :options="impressionsChart" />
            </article>
            <article>
                <h2>Impression over time</h2>
                <BaseChart
                    name="Duration"
                    :options="impressionsOverTimeChart"
                />
            </article>
        </section>
        <section class="actions">
            <router-link to="/stats">
                <Bttn class="outlined">Back</Bttn>
            </router-link>
        </section>
    </main>
</template>
<script>
import DataTable from "js/components/tables/DataTable";
import BaseChart from "js/components/charts/BaseChart";
import LoadingScreen from "js/components/common/LoadingScreen";
import { fetch } from "js/lib/server.js";
import { getSimpleBarChart, getBarChart, getChart } from "js/lib/charts.js";
export default {
    components: {
        LoadingScreen,
        DataTable,
        BaseChart,
    },
    data() {
        return {
            loaded: false,
            header: [],
            body: [],
            hostChart: null,
            impressionsChart: null,
            impressionsOverTimeChart: null,
        };
    },
    mounted() {
        fetch("/api/stats/places").then((response) => {
            this.table = response.data.table;

            this.hostChart = getBarChart(
                response.data.charts.host.labels,
                [
                    {
                        label: "Places",
                        data: response.data.charts.host.lines.places,
                        yAxisID: "yLeft",
                    },
                    {
                        label: "Nights",
                        data: response.data.charts.host.lines.nights,
                        yAxisID: "yRight",
                    },
                ],
                {
                    scales: {
                        x: {
                            stepSize: 1,
                        },
                        yLeft: {
                            beginAtZero: true,
                            ticks: {
                                stepSize: 1,
                            },
                            grid: {
                                lineWidth: 2,
                            },
                        },
                        yRight: {
                            beginAtZero: true,
                            position: "right",
                        },
                    },
                }
            );

            this.impressionsChart = getSimpleBarChart(
                "Places",
                response.data.charts.impression.labels,
                response.data.charts.impression.lines.places
            );

            let impressionsOverTimeData =
                response.data.charts.impressions_time.lines.places;
            let factor = 1.5;
            this.impressionsOverTimeChart = getChart(
                "bubble",
                undefined,
                [
                    {
                        label: "Places",
                        data: impressionsOverTimeData.map((point) => {
                            return {
                                x: point.x,
                                y: point.y,
                                r: point.r * factor,
                            };
                        }),
                        tooltip: {
                            callbacks: {
                                label: (context) => {
                                    let r = Math.round(context.raw.r / factor);
                                    return `Places: ${r}`;
                                },
                            },
                        },
                    },
                ],
                {
                    scales: {
                        x: {
                            ticks: {
                                stepSize: 1,
                                callback: (value) => value + "",
                            },
                        },
                        y: {
                            ticks: {
                                stepSize: 1,
                                callback: (value) =>
                                    this.$enumGet("impression", value),
                            },
                        },
                    },
                }
            );

            this.loaded = true;
        });
    },
};
</script>
